import {Component, OnDestroy, OnInit} from '@angular/core';
import {IAppState} from '@app/core/store/state/app.state';
import {selectDepartment} from '@app/core/store/selectors/session.selectors';
import {Store} from '@ngrx/store';
import {Observable, Subject} from 'rxjs';
import {Moment} from 'moment';
import {Department} from '@app/core/models/department.model';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {getCurrentState} from '@app/core/helpers';
import {DayNote} from '@app/core/models/day-note.model';
import {selectSelectedDate, selectSelectedDayNote} from '@app/core/store/selectors/daynotes.selectors';
import {DeleteDayNote, PatchDayNote, PostDayNote} from '@app/core/store/actions/daynotes.actions';
import {filter, takeUntil} from 'rxjs/operators';

@Component({
	selector: 'app-day-note-popup',
	templateUrl: './day-note-popup.component.html',
	styleUrls: ['./day-note-popup.component.scss'],
})
export class DayNotePopupComponent implements OnInit, OnDestroy {
	public selectedDate$: Observable<Moment> = this.store.select(selectSelectedDate);
	public selectedDepartment$: Observable<Department> = this.store.select(selectDepartment);
	public selectedDayNote$: Observable<DayNote> = this.store.select(selectSelectedDayNote);
	public dayNoteId: number;
	public form: FormGroup;

	private _destroy$: Subject<void> = new Subject<void>();

	constructor(
		public store: Store<IAppState>,
		public dialogRef: MatDialogRef<DayNotePopupComponent>,
		private formBuilder: FormBuilder,
	) {
	}

	public ngOnInit(): void {
		this.initForm();
		this.initSubscriptions();
	}

	public save(): void {
		if (this.form.invalid) {
			return;
		}
		const data = {
			...this.form.value,
			start: getCurrentState(this.store).dayNotes.selectedDate.format('YYYY-MM-DD'),
			end: getCurrentState(this.store).dayNotes.selectedDate.format('YYYY-MM-DD'),
		};
		if (this.dayNoteId) {
			this.store.dispatch(new PatchDayNote(this.dayNoteId, data));
		} else {
			this.store.dispatch(new PostDayNote(data));
		}
		this.dialogRef.close();
	}

	public close(): void {
		this.dialogRef.close();
	}

	public delete(): void {
		this.store.dispatch(new DeleteDayNote(this.dayNoteId));
		this.dialogRef.close();
	}

	public ngOnDestroy(): void {
		this._destroy$.next();
		this._destroy$.complete();
	}

	private initForm(): void {
		this.form = this.formBuilder.group({
			note: ['', Validators.required],
			hidden_note: [false],
		});
	}

	private initSubscriptions(): void {
		this.selectedDayNote$
			.pipe(
				takeUntil(this._destroy$),
				filter(dayNote => !!dayNote),
			)
			.subscribe(dayNote => {
				this.form.patchValue(dayNote, {emitEvent: false});
				this.dayNoteId = dayNote.id;
			});
	}

}
